import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  defaultSubscriptionCardData,
  ManageSubscriptionsService,
  SubscriptionCardData,
} from '../utils/manage-subscriptions.service';
import { PartnerService } from '../../core/partner.service';
import { switchMap, map, take, withLatestFrom } from 'rxjs/operators';
import {
  VBP2024_STARTER_SUBSCRIPTION_ID,
  VBP2024_PROFESSIONAL_SUBSCRIPTION_ID,
  VBP2024_PREMIUM_SUBSCRIPTION_ID,
} from '@galaxy/partner';

@Component({
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.scss'],
  standalone: false,
})
export class ManageSubscriptionsComponent implements OnInit {
  cards$: Observable<SubscriptionCardData[]>;
  defaultSubscriptionCardData = defaultSubscriptionCardData;

  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private readonly manageSubscriptionsService: ManageSubscriptionsService,
    private readonly router: Router,
    private readonly partnerService: PartnerService,
  ) {}

  ngOnInit(): void {
    const cardTypesToHide = ['Emails'];
    const vbp2024TierIds = [
      VBP2024_STARTER_SUBSCRIPTION_ID,
      VBP2024_PROFESSIONAL_SUBSCRIPTION_ID,
      VBP2024_PREMIUM_SUBSCRIPTION_ID,
    ];
    const is2024Tier$ = this.partnerId$.pipe(
      switchMap((partnerId) => this.partnerService.getPartnerByPartnerId(partnerId)),
      map((partner) => vbp2024TierIds.includes(partner.subscription_tier)),
      take(1),
    );
    this.cards$ = this.manageSubscriptionsService.cardData$.pipe(
      withLatestFrom(is2024Tier$),
      map(([cardData, is2024Tier]) => {
        if (is2024Tier) {
          return cardData.filter((card) => !cardTypesToHide.includes(card.type));
        }
        return cardData;
      }),
    );
  }

  comparePlans(): void {
    this.router.navigateByUrl('upgrade-subscription-tier');
  }
}
